import { useQuery, useMutation } from '@tanstack/react-query';
import {
  GET_USER_COMMENT_ENDPOINT,
  GET_COMMENT_ENDPOINT,
} from '@/app/_libs/utils/constants/endpoints';

// Get user comments*****************************************
async function getUserComments(token, page, filter) {
  const res = await fetch(`${GET_USER_COMMENT_ENDPOINT}`, {
    method: 'get',
    headers: new Headers({
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
    }),
  });
  const userComments = await res.json();
  return userComments;
}
//Get product comments ******************************************
async function getProductComments({ id, page, filter }) {
  let params = '';
  if (page != 1) {
    params = 'page=' + page;
  }
  if (filter != '') {
    if (params != '') params += '&';
    params += 'filter=' + filter;
  }

  const data = await fetch(`${GET_COMMENT_ENDPOINT}/product/${id}?${params}`);
  const resdata = await data.json();

  return resdata;
}
// Update product commments **************************************
async function updateComments({
  token,
  values,
  images,
  advantages,
  disAdvantages,
  indicies,
  productId,
  starRating,
  purchaseOffer,
}) {
  var formData = new FormData();
  formData.append('product_id', productId);
  formData.append('title', values.cmSubject);
  formData.append('content', values.cmContent);
  formData.append('anonymous', `${values.anonymous ? '1' : '0'}`);
  formData.append('score', starRating);
  purchaseOffer != null && formData.append('recommend', purchaseOffer);

  if (images.length > 0) {
    images.map((image, index) => {
      formData.append([`images[${index}]`], image);
    });
  }
  if (advantages.length > 0) {
    advantages.map((adv, index) => {
      formData.append([`strengths[${index}]`], adv);
    });
  }
  if (disAdvantages.length > 0) {
    disAdvantages.map((disAdv, index) => {
      formData.append([`weakness[${index}]`], disAdv);
    });
  }
  indicies.map((indice, index) => {
    formData.append([`${indice.slug}`], indice.value / 5 + 1);
  });
  const res = await fetch(`${GET_COMMENT_ENDPOINT}`, {
    method: 'POST',
    body: formData,
    headers: new Headers({
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
    }),
  });
  const resdata = await res.json();
  return resdata.data;
}
// use user comments hook**************************
const useUserComments = (token, page, cmStatus) => {
  const fallback = [];
  const { data: userComments = fallback } = useQuery({
    queryKey: ['userComments', token, page, cmStatus],
    queryFn: () => getUserComments(token, page, cmStatus),
    initialData: initiaData,
  });
  return { userComments };
};
// use product comments hook
const useUpdateComment = () => {
  return useMutation({
    mutationFn: (data) => updateComments(data),
  });
};
const useProductComments = (id, filter = '', page = 1) => {
  const fallback = [];
  const { data: productCommentsInfo = fallback } = useQuery({
    queryKey: ['productComments', id, page, filter],
    queryFn: () => getProductComments({ id, page, filter }),
    staleTime: 60000,
  });
  return { productCommentsInfo };
};

export { useUserComments, useUpdateComment, useProductComments };
